// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2q0R1","col":"Table_col__dU4Pv","fulfillmentStatus":"Table_fulfillmentStatus__2suj5","emailCol":"Table_emailCol__2U4NC"};